import React from 'react';
import { useSelector } from 'react-redux';
import { TabComponent } from './components/tabComponent';
import { Tablas } from '../../shared/helpers/tablas';
import { FormularioBonoDescuento } from './components/formularioBonoDescuento';
import FormularioGenerico from './components/formGenerico';


const Mantenedores = ({ path }) => {
    const { user: currentUser } = useSelector(state => state.auth)

    const menuTabs = [
        {
            path: 'tipoBono',
            tabs: [
                {
                    title: 'Lista de Tipos de Bonos',
                    eventKey: 'listaBonos',
                    component: <Tablas tipo='ListaBonos' user={currentUser} />,
                },
                {
                    title: 'Lista de Descuentos',
                    eventKey: 'listaDescuentos',
                    component: <Tablas tipo='ListaDescuentos' user={currentUser} />,
                },
                {
                    title: 'Lista de BND',
                    eventKey: 'ListaBnd',
                    component: <Tablas tipo='ListaBnd' user={currentUser} />,
                },
                {
                    title: 'Lista de REM',
                    eventKey: 'ListaRem',
                    component: <Tablas tipo='ListaRem' user={currentUser} />,
                },
                {
                    title: 'Lista de IFE',
                    eventKey: 'ListaIfe',
                    component: <Tablas tipo='ListaIfe' user={currentUser} />,
                },
                {
                    title: 'Nuevo Dato',
                    eventKey: 'nuevoBono',
                    component: <FormularioGenerico user={currentUser} type={'bonosDescuentos'}/>,
                }
            ]
        },
        {
            path: 'empresa',
            tabs: [
                {
                    title: 'Lista de Empresas',
                    eventKey: 'listaEmpresas',
                    component: <Tablas tipo='empresa' user={currentUser} />,
                },
                {
                    title: 'Nueva Empresa',
                    eventKey: 'nuevaEmpresa',
                    component: <FormularioGenerico user={currentUser} type={'empresa'} />,
                }
            ]
        },
        {
            path: 'tipo_flota',
            tabs: [
                {
                    title: 'Lista de Flota',
                    eventKey: 'listaFlota',
                    component: <Tablas tipo='tipo_flota' user={currentUser} />,
                },
                {
                    title: 'Nuevo Dato',
                    eventKey: 'nuevaFlota',
                    component: <FormularioGenerico user={currentUser} type={'tipo_flota'} />,
                }
            ]
        },
        {
            path: 'tms',
            tabs: [
                {
                    title: 'Lista de TMS',
                    eventKey: 'listaTMS',
                    component: <Tablas tipo='tms' user={currentUser} />,
                },
                {
                    title: 'Documento Tributario',
                    eventKey: 'listaDocumentos',
                    component: <Tablas tipo='tipo_documento' user={currentUser} />,
                },
                {
                    title: 'Nuevo Dato',
                    eventKey: 'nuevoTMS',
                    component: <FormularioGenerico user={currentUser} type={'tms'} />,
                }
            ]
        },
        {
            path: 'vehiculo',
            tabs: [
                {
                    title: 'Tipo de Vehículos',
                    eventKey: 'listaVehiculos',
                    component: <Tablas tipo='tipo_vehiculo' user={currentUser} />,
                },
                {
                    title: 'Vehículos',
                    eventKey: 'vehiculos',
                    component: <Tablas tipo='vehiculo' user={currentUser} />,
                },
                {
                    title: 'Nuevo Dato',
                    eventKey: 'nuevoVehiculo',
                    component: <FormularioGenerico user={currentUser} type={'vehiculo'} />,
                }
            ]
        },
        {
            path: 'banco',
            tabs: [
                {
                    title: 'Lista de Bancos',
                    eventKey: 'listaBancos',
                    component: <Tablas tipo='banco' user={currentUser} />,
                },
                {
                    title: 'Tipo de Cuentas',
                    eventKey: 'listaCuentas',
                    component: <Tablas tipo='tipo_cuenta' user={currentUser} />,
                },
                {
                    title: 'Nuevo Dato',
                    eventKey: 'nuevoBanco',
                    component: <FormularioGenerico user={currentUser} type={'banco'} />,
                }
            ]
        },
        {
            path: 'directorio',
            tabs: [
                {
                    title: 'Lista de Conductores',
                    eventKey: 'listaConductores',
                    component: <Tablas tipo='conductores' user={currentUser} />,
                },
                {
                    title: 'Nuevo Conductor',
                    eventKey: 'nuevoConductor',
                    component: <FormularioGenerico user={currentUser} type='conductores' />,
                }
            ]
        },
        {
            path: 'bonosDescuentos',
            tabs: [
                {
                    title: 'Bonos',
                    eventKey: 'listaBonos',
                    component: <Tablas tipo='bonos' user={currentUser} />,
                },
                {
                    title: 'Descuentos',
                    eventKey: 'descuentos',
                    component: <Tablas tipo='descuentos' user={currentUser} />,
                },
                {
                    title: 'BND',
                    eventKey: 'bnd',
                    component: <Tablas tipo='bnd' user={currentUser} />,
                },
                {
                    title: 'REM',
                    eventKey: 'rem',
                    component: <Tablas tipo='rem' user={currentUser} />,
                },
                {
                    title: 'IFE',
                    eventKey: 'ife',
                    component: <Tablas tipo='ife' user={currentUser} />,
                },
                {
                    title: 'Ingreso Bono o Descuento',
                    eventKey: 'nuevoBono',
                    component: <FormularioBonoDescuento user={currentUser}  />,
                }
            ]
        },
        {
            path: 'cierre',
            tabs: [
                {
                    title: 'Lista de Cierres',
                    eventKey: 'listaCierres',
                    component: <Tablas tipo='cierre' user={currentUser} />,
                },
                {
                    title: 'Nuevo Cierre',
                    eventKey: 'nuevoCierre',
                    component: <FormularioGenerico user={currentUser} type={'cierre'} />,
                }
            ]
        }
    ]
    const currentTab = menuTabs.find(tab => tab.path === path);

    return (
        <TabComponent user={currentUser} currentTab={currentTab} />
    );
};

export default Mantenedores;